module.exports = __webpack_public_path__ + "static/media/bitly.ae8a0c9e.md";